<section
  class="tw-m-auto tw-flex tw-flex-col tw-rounded-xl tw-border tw-border-gray-200 tw-bg-white tw-p-4 tw-pb-6 tw-shadow-sm dark:tw-border-gray-600 dark:tw-bg-gray-800"
  id="api-keys"
>
  <div class="tw-mb-4 tw-flex tw-flex-col tw-items-start tw-gap-1">
    <div class="tw-flex tw-w-full tw-flex-col tw-gap-4 lg:tw-flex-row lg:tw-items-start lg:tw-justify-between">
      <div class="tw-flex tw-flex-col tw-gap-1">
        <h2 class="tw-font-inter tw-text-base md:tw-text-lg tw-font-bold tw-text-gray-700 dark:tw-text-gray-100">
          {{ 'v2.orgSettings.apiKeys.apiKeys' | translate }}
        </h2>
        <p class="tw-text-start tw-font-inter tw-text-sm tw-font-normal tw-text-gray-500 dark:tw-text-gray-300">
          {{ 'v2.orgSettings.apiKeys.description' | translate }}
        </p>
      </div>

      @if (!showInitialEmptyState()) {
      <button
        type="button"
        class="tw-inline-flex tw-shrink-0 tw-items-center tw-gap-2 tw-self-start tw-rounded-md tw-bg-blue-600 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-blue-700"
        (click)="openCreateApiKeyModal()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <g clip-path="url(#clip0_api_keys_create)">
            <path
              d="M6.00146 0.499023V5.99902M6.00146 5.99902V11.499M6.00146 5.99902H11.5015M6.00146 5.99902H0.501465"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_api_keys_create">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
        {{ 'v2.orgSettings.apiKeys.create' | translate }}
      </button>
      }
    </div>
  </div>

  @if (showInitialEmptyState()) {
  <div class="tw-flex tw-flex-col tw-items-center tw-gap-6">
    <div class="tw-flex tw-items-center tw-justify-center tw-p-4">
      <img [src]="emptyStateSrc" alt="" class="tw-h-[180px] tw-w-[234px] md:tw-h-[220px] md:tw-w-[286px]" />
    </div>
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
      <p class="tw-mb-2 tw-text-center tw-font-inter tw-text-base tw-font-bold tw-leading-8 tw-text-gray-900 dark:tw-text-white md:tw-text-xl">
        {{ 'v2.orgSettings.apiKeys.noApiKeysYet' | translate }}
      </p>
      <p
        class="tw-mb-6 tw-max-w-[650px] tw-self-stretch tw-text-center tw-font-inter tw-text-xs tw-font-medium tw-leading-4 tw-text-gray-500 dark:tw-text-gray-400 md:tw-text-base md:tw-leading-6"
      >
        {{ 'v2.orgSettings.apiKeys.noApiKeysYetDescription' | translate }}
      </p>
      <button
        type="button"
        class="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-bg-blue-600 tw-px-5 tw-py-2.5 md:tw-py-3"
        (click)="openCreateApiKeyModal()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-[14px] tw-w-[14px] md:tw-h-4 md:tw-w-4" viewBox="0 0 14 14" fill="none">
          <g clip-path="url(#clip0_api_keys_create_first)">
            <path
              d="M7.00163 0.582031V6.9987M7.00163 6.9987V13.4154M7.00163 6.9987H13.4183M7.00163 6.9987H0.584961"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_api_keys_create_first">
              <rect width="14" height="14" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span class="tw-font-inter tw-text-sm tw-font-medium tw-leading-5 tw-text-white md:tw-text-base md:tw-leading-6">
          {{ 'v2.orgSettings.apiKeys.createFirst' | translate }}
        </span>
      </button>
    </div>
  </div>
  } @else {
  <div
    class="api-keys-list-scroll tw-h-fit tw-max-h-[400px] tw-flex tw-min-h-0 tw-flex-col tw-gap-3 tw-overflow-y-auto"
    infiniteScroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="150"
    [immediateCheck]="true"
    [infiniteScrollDisabled]="infiniteScrollDisabled()"
    (scrolled)="onApiKeysListScroll()"
  >
    @if (isLoadingApiKeys()) {
    <div class="tw-flex tw-flex-col tw-gap-3" role="status" [attr.aria-label]="'v2.orgSettings.apiKeys.apiKeys' | translate">
      @for (_skeleton of [1, 2, 3]; track $index) {
      <div class="tw-overflow-hidden tw-rounded-xl tw-border tw-border-gray-200 tw-bg-gray-50 tw-p-4 dark:tw-border-gray-600 dark:tw-bg-gray-800">
        <div class="tw-flex tw-items-center tw-gap-3">
          <ngx-skeleton-loader
            count="1"
            class="tw-flex-1"
            [theme]="{
              width: '100%',
              height: '16px',
              'border-radius': '4px',
              backgroundColor: getSkeletonTheme().backgroundColor,
              color: getSkeletonTheme().color,
              marginBottom: '0'
            }"
            animation="pulse"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '120px',
              height: '32px',
              'border-radius': '6px',
              backgroundColor: getSkeletonTheme().backgroundColor,
              color: getSkeletonTheme().color,
              marginBottom: '0'
            }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>
      </div>
      }
    </div>
    } @else { @for (apiKey of apiKeys(); track apiKey.id) {
    <api-key-card
      [apiToken]="apiKey"
      [events]="events()"
      [workspaceName]="workspaceName()"
      (editRequested)="onEditRequested($event)"
      (deleteRequested)="onDeleteRequested($event)"
      (rotateRequested)="onRotateRequested($event)"
    ></api-key-card>
    } @if (isLoadingMore()) {
    <ngx-skeleton-loader
      count="1"
      [theme]="{ width: '100%', height: '88px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color, marginBottom: '0' }"
      animation="pulse"
    ></ngx-skeleton-loader>
    } }
  </div>
  }
</section>

@if (isModalOpened(createModalId)) {
<create-api-key-modal
  [id]="createModalId"
  [events]="events()"
  [isLoadingEvents]="isLoadingEvents()"
  (apiKeyCreated)="onApiKeyCreated($event)"
  (cancelled)="closeCreateApiKeyModal()"
></create-api-key-modal>
} @if (isModalOpened(editModalId) && editingTokenId(); as tokenId) {
<create-api-key-modal
  [id]="editModalId"
  [apiTokenId]="tokenId"
  [events]="events()"
  [isLoadingEvents]="isLoadingEvents()"
  (apiKeyUpdated)="onApiKeyUpdated($event)"
  (cancelled)="closeEditApiKeyModal()"
></create-api-key-modal>
} @if (createdToken(); as token) {
<copy-api-key-modal [id]="createdModalId" [token]="token" [titleKey]="copyModalTitleKey()" (closed)="closeCreatedApiKeyModal()"></copy-api-key-modal>
} @if (isModalOpened(deleteModalId)) {
<delete-modal
  [id]="deleteModalId"
  [message]="deleteConfirmMessage()"
  [confirmBtnLabel]="'v2.orgSettings.apiKeys.confirmYes' | translate"
  [cancelBtnLabel]="'v2.orgSettings.apiKeys.confirmNo' | translate"
  [widthClass]="'tw-w-[416px]'"
  (onDelete)="confirmApiKeyDeletion()"
  (onCancel)="cancelApiKeyDeletion()"
></delete-modal>
} @if (isModalOpened(rotateModalId)) {
<delete-modal
  [id]="rotateModalId"
  [message]="rotateConfirmMessage()"
  [confirmBtnLabel]="'v2.orgSettings.apiKeys.confirmYes' | translate"
  [cancelBtnLabel]="'v2.orgSettings.apiKeys.confirmNo' | translate"
  (onDelete)="confirmApiKeyRotation()"
  (onCancel)="cancelApiKeyRotation()"
></delete-modal>
}
